// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-tab-border[data-v-11726e4a] .custom-tab-container {\n  border-bottom: none !important;\n}\n[data-v-11726e4a] .hide-tab-header .nav-item {\n  display: none !important;\n}\n@media only screen and (max-width: 768px) {\n.hide-tab-header[data-v-11726e4a] .custom-tab-extended .nav-item,\n  .hide-tab-header[data-v-11726e4a] .custom-tab-extended .nav-left-icon,\n  .hide-tab-header[data-v-11726e4a] .custom-tab-extended .nav-right-icon {\n    display: none !important;\n}\n}", ""]);
// Exports
module.exports = exports;
